module.exports = __webpack_public_path__ + "static/media/add-product-to-cart-icon.1f783827.svg";